import { makeAutoObservable, runInAction, toJS } from "mobx";
import { PaginationData } from "../../../types/common";
import { Product } from "../../../types/product";
import http from "../../../libs/http";
import appStore from "../../../stores/appStore";

class SearchPageStore {
  products: PaginationData<Product> | undefined = undefined;

  isLoading: boolean = false;

  isAvailableInCity: boolean = false;

  brandsOption : {
    value: string;
    label: string;
  }[] = [];

  // Filters
  priceFrom: string = "";
  priceTo: string = "";
  isOriginal: boolean = false;
  brand: string = "";
  sortBy: "name" | "price" | "" = "";
  sortDirection: "asc" | "desc" | "" = "";

  errorOnFetch: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async searchProducts(
    searchString: string,
    page = 1,
    per_page = 28,
    url?: string
  ) {
    // cancelRequests();

    runInAction(() => {
      this.errorOnFetch = false;
    });

    this.startLoading();
    try {
      if (url) {
        const { data } = await http.get<PaginationData<Product> & { 
        brands: {
            value: string;
            label: string;
        }[];
       }>(url);

        runInAction(() => {          
          this.products = data;
           if (this.brandsOption?.length === 0) {
        this.brandsOption = [
            {
                value: "",
                label: "Все производители",
            },
            ...data.brands
        ];
        }
        });
        // if (this.isAvailableInCity) {
        //   await this.getAvailables();
        // }
        this.finishLoading();
        return;
      }
      const { data } = await http.get<PaginationData<Product> & { 
        brands: {
            value: string;
            label: string;
        }[];
       }>(
        `api/products/search`,
        {
          params: {
            page,
            per_page,
            search: searchString,
            city: appStore.selectedCity,
            isAvailableInCity: this.isAvailableInCity,
            price_from: this.priceFrom ? Number(this.priceFrom) : undefined,
            price_to: this.priceTo ? Number(this.priceTo) : undefined,
            is_original: this.isOriginal ? true : false,
            brand: this.brand || undefined,
            sort_by: this.sortBy || undefined,
            sort_direction: this.sortDirection || undefined,
          },
        }
      );
      runInAction(() => {
        this.products = data;
         if (this.brandsOption?.length === 0) {
        this.brandsOption = [
            {
                value: "",
                label: "Все производители",
            },
            ...data.brands
        ];
        }
      });
      // if (this.isAvailableInCity) {
      //   await this.getAvailables();
      // }
      this.finishLoading();
    } catch {
      runInAction(() => {
        this.errorOnFetch = true;
      });
      this.finishLoading();
    }

  }

  startLoading() {
    runInAction(() => {
      this.isLoading = true;
    });
  }

  finishLoading() {
    runInAction(() => {
      this.isLoading = false;
    });
  }

  async getAvailables() {
    this.startLoading();
    const { data } = await http.post<Product[]>("api/products/availables", {
      products: toJS(this.products?.data),
      city: appStore.selectedCity,
    });

    runInAction(() => {
      if (this.products) {
        // Create a new object to maintain immutability
        this.products = {
          ...this.products,
          data: data,
        };
      }
    });

    this.finishLoading();
  }

  toggleAvailableInCity() {
    runInAction(() => {
      this.isAvailableInCity = !this.isAvailableInCity;
    });
  }

  setPriceFrom(value: string) {
    runInAction(() => {
      this.priceFrom = value;
    });
  }

  setPriceTo(value: string) {
    runInAction(() => {
      this.priceTo = value;
    });
  }

  toggleIsOriginal() {
    runInAction(() => {
      this.isOriginal = !this.isOriginal;
    });
  }

  setBrand(value: string) {
    runInAction(() => {
      this.brand = value;
    });
  }

  resetFilters() {
    runInAction(() => {
      this.priceFrom = "";
      this.priceTo = "";
      this.isOriginal = false;
      this.brand = "";
      this.sortBy = "";
      this.sortDirection = "";
    });
  }

  setSort(by: "name" | "price" | "", direction: "asc" | "desc" | "") {
    runInAction(() => {
      this.sortBy = by;
      this.sortDirection = direction;
    });
  }
}

export default new SearchPageStore();
